/* NewsAllegato.js 1.0 22/09/2026
Visualizzazione allegati NEWS nella PWA:
- visualizzazione responsive immagini JPG/JPEG/PNG
- visualizzazione esclusivamente della prima pagina dei PDF
- apertura dell'allegato a tutto schermo tramite click/tap
*/

import React, { useEffect, useRef, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc =
    `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function NewsAllegato(props) {

    const contenitoreRef = useRef(null);

    const [larghezza, setLarghezza] = useState(300);
    const [visualizzazioneGrande, setVisualizzazioneGrande] = useState(false);

    useEffect(() => {

        function aggiornaLarghezza() {

            if (contenitoreRef.current) {

                const nuovaLarghezza =
                    contenitoreRef.current.getBoundingClientRect().width;

                if (nuovaLarghezza > 0) {
                    setLarghezza(nuovaLarghezza);
                }
            }
        }

        aggiornaLarghezza();

        window.addEventListener('resize', aggiornaLarghezza);

        return () => {
            window.removeEventListener('resize', aggiornaLarghezza);
        };

    }, [visualizzazioneGrande]);


    function visualizzaContenuto(grande=false) {

        const larghezzaDisponibile = grande
            ? Math.min(window.innerWidth - 20, 1000)
            : larghezza;

        if (props.tipoFile && props.tipoFile.startsWith("image")) {

            return (
                <img
                    src={props.contenutoFile}
                    alt="Allegato news"
                    style={{
                        display: "block",
                        maxWidth: "100%",
                        maxHeight: grande ? "calc(100vh - 20px)" : 700,
                        width: "auto",
                        height: "auto",
                        objectFit: "contain",
                        marginLeft: "auto",
                        marginRight: "auto"
                    }}
                />
            );

        }

        if (props.tipoFile === "application/pdf") {

            return (
                <div
                    style={{
                        width:"100%",
                        display:"flex",
                        justifyContent:"center"
                    }}
                >
                    <Document
                        file={props.contenutoFile}
                        loading={<div style={{padding:10}}>Caricamento PDF...</div>}
                        error={<div style={{padding:10}}>Impossibile visualizzare il PDF</div>}
                    >
                        <Page
                            pageNumber={1}
                            width={larghezzaDisponibile}
                            renderTextLayer={false}
                            renderAnnotationLayer={false}
                        />
                    </Document>
                </div>
            );
        }

        return null;
    }


    if (!props.contenutoFile) return null;


    return (
        <>
            <div
                ref={contenitoreRef}
                style={{
                    width:"100%",
                    marginTop:10,
                    marginBottom:10,
                    overflow:"hidden",
                    cursor:"pointer",
                    display:"flex",
                    justifyContent:"center"
                }}
                onClick={() => setVisualizzazioneGrande(true)}
            >
                {visualizzaContenuto(false)}
            </div>


            {visualizzazioneGrande &&
                <div
                    style={{
                        position:"fixed",
                        top:0,
                        left:0,
                        right:0,
                        bottom:0,
                        zIndex:10000,
                        backgroundColor:"rgba(0,0,0,0.9)",
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"center",
                        overflow:"auto",
                        padding:10,
                        boxSizing:"border-box"
                    }}
                    onClick={() => setVisualizzazioneGrande(false)}
                >

                    <div
                        style={{
                            position:"relative",
                            width:"100%",
                            maxWidth:1000,
                            display:"flex",
                            justifyContent:"center"
                        }}
                    >

                        {visualizzaContenuto(true)}

                        <div
                            style={{
                                position:"fixed",
                                top:10,
                                right:15,
                                width:40,
                                height:40,
                                borderRadius:20,
                                backgroundColor:"rgba(0,0,0,0.7)",
                                color:"white",
                                fontSize:28,
                                lineHeight:"36px",
                                textAlign:"center",
                                fontWeight:"bold",
                                zIndex:10001
                            }}
                            onClick={(e) => {
                                e.stopPropagation();
                                setVisualizzazioneGrande(false);
                            }}
                        >
                            ×
                        </div>

                    </div>

                </div>
            }
        </>
    );
}

export default NewsAllegato;